import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/caikuma_02_a.png'


const _withScopeId = n => (_pushScopeId("data-v-41888252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4 mx-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-18 title" }, "\n          審査を開始しました！\n        "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "\n          審査完了後、メールアドレスに認証結果を送信します\n        ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mascot" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-14 text-center information" }, [
  /*#__PURE__*/_createTextVNode("\n        審査は"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-size-18 text-weight-600" }, "1"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-weight-600" }, "時間以内"),
  /*#__PURE__*/_createTextVNode("で完了します\n      ")
], -1))
const _hoisted_5 = { class: "mt-3 text-size-12 text-mild" }
const _hoisted_6 = { class: "mt-4 promotion" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500" }, "\n          招待コードの登録\n        ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-size-12 text-mild" }, "\n          招待コードを登録いただき資格認証完了後30日以内にお仕事をすると、招待した方にポイントが付与されます。\n        ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_TextFieldGroup = _resolveComponent("TextFieldGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      入力完了\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(),
      _hoisted_3,
      _createTextVNode(),
      _hoisted_4,
      _createTextVNode(),
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode("\n        認証結果が届かない場合、"),
        _createVNode(_component_RouterLink, {
          to: { name: 'Mypage' },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("マイページ")
          ], undefined, true),
          _: 1
        }),
        _createTextVNode("からご連絡ください。\n      ")
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createTextVNode(),
        _hoisted_8,
        _createTextVNode(),
        _createVNode(_component_CustomValidationObserver, { ref: "vObserver" }, {
          default: _withCtx(({ handleSubmit }) => [
            _createVNode(_component_ValidationProvider, {
              name: "招待コード",
              rules: { required: true, length: 8 },
              vid: "code"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(_component_TextFieldGroup, {
                  modelValue: _ctx.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
                  label: "招待コード",
                  placeholder: "",
                  validationState: validationState,
                  disabled: _ctx.isCodeApplied,
                  class: "mt-2"
                }, null, 8, ["modelValue", "validationState", "disabled"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_AppButton, {
              block: "",
              class: "mt-3",
              variant: "success",
              disabled: _ctx.isCodeApplied,
              onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitCode))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.submitCodeButtonLabel), 1)
              ], undefined, true),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _: 1
        }, 512)
      ]),
      _createTextVNode(),
      _createVNode(_component_AppButton, {
        block: "",
        class: "mt-4",
        onClick: _ctx.onClickGoToSearch
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n        仕事一覧へ\n      ")
        ], undefined, true),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}